export function copyProperties<T, U0>(dst: T, src0: U0): T & U0;
export function copyProperties<T, U0, U1>(
  dst: T,
  src0: U0,
  src1: U1
): T & U0 & U1;
export function copyProperties<T, U0, U1, U2>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2
): T & U0 & U1 & U2;
export function copyProperties<T, U0, U1, U2, U3>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3
): T & U0 & U1 & U2 & U3;
export function copyProperties<T, U0, U1, U2, U3, U4>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4
): T & U0 & U1 & U2 & U3 & U4;
export function copyProperties<T, U0, U1, U2, U3, U4, U5>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5
): T & U0 & U1 & U2 & U3 & U4 & U5;
export function copyProperties<T, U0, U1, U2, U3, U4, U5, U6>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6;
export function copyProperties<T, U0, U1, U2, U3, U4, U5, U6, U7>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6,
  src7: U7
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6 & U7;
export function copyProperties<T, U0, U1, U2, U3, U4, U5, U6, U7, U8>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6,
  src7: U7,
  src8: U8
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6 & U7 & U8;
export function copyProperties<T, U0, U1, U2, U3, U4, U5, U6, U7, U8, U9>(
  dst: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6,
  src7: U7,
  src8: U8,
  src9: U9
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6 & U7 & U8 & U9;
export function copyProperties<T, U>(dst: T, ...srcs: U[]): T & U;
export function copyProperties(dst: object, ...srcs: object[]) {
  for (const src of srcs) {
    const descriptors = Object.getOwnPropertyDescriptors(src);
    Object.defineProperties(dst, descriptors);
  }
  return dst;
}
export function createObject<T, U0>(proto: T, src0: U0): T & U0;
export function createObject<T, U0, U1>(
  proto: T,
  src0: U0,
  src1: U1
): T & U0 & U1;
export function createObject<T, U0, U1, U2>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2
): T & U0 & U1 & U2;
export function createObject<T, U0, U1, U2, U3>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3
): T & U0 & U1 & U2 & U3;
export function createObject<T, U0, U1, U2, U3, U4>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4
): T & U0 & U1 & U2 & U3 & U4;
export function createObject<T, U0, U1, U2, U3, U4, U5>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5
): T & U0 & U1 & U2 & U3 & U4 & U5;
export function createObject<T, U0, U1, U2, U3, U4, U5, U6>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6;
export function createObject<T, U0, U1, U2, U3, U4, U5, U6, U7>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6,
  src7: U7
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6 & U7;
export function createObject<T, U0, U1, U2, U3, U4, U5, U6, U7, U8>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6,
  src7: U7,
  src8: U8
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6 & U7 & U8;
export function createObject<T, U0, U1, U2, U3, U4, U5, U6, U7, U8, U9>(
  proto: T,
  src0: U0,
  src1: U1,
  src2: U2,
  src3: U3,
  src4: U4,
  src5: U5,
  src6: U6,
  src7: U7,
  src8: U8,
  src9: U9
): T & U0 & U1 & U2 & U3 & U4 & U5 & U6 & U7 & U8 & U9;
export function createObject<T, U>(proto: T, ...srcs: U[]): T & U;
export function createObject(proto: object, ...srcs: object[]) {
  return copyProperties(Object.create(proto), ...srcs);
}
